/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.75 18.75h12.5v-3.125a4.38 4.38 0 00-4.375-4.375h-3.75a4.38 4.38 0 00-4.375 4.375v3.125zM5.625 5.625a4.375 4.375 0 108.75 0 4.375 4.375 0 00-8.75 0z"/>'
  }
})
